// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  CostFilter,
  getCosts,
  serializeCostFilter,
} from '@/costs/api/get-costs';
import { useSuspenseQuery } from '@tanstack/react-query';

interface UseCostsOptions {
  filter?: CostFilter;
}

/**
 * Hook to fetch and manage costs data
 *
 * @param options Optional filter parameters
 * @returns An object containing the costs array, total count, and loading states
 */
export function useCosts(options: UseCostsOptions = {}) {
  const filter = options.filter ?? { pageSize: 50 };
  const serializedFilter = serializeCostFilter(filter);

  const { data, isFetching } = useSuspenseQuery({
    queryKey: ['costs', 'list', serializedFilter],
    queryFn: () => getCosts(filter),
  });

  return {
    costs: data.results,
    totalCount: data.totalCount,
    isFetching,
  };
}
